import { TThunkAction } from '../../types/redux';
import {
  fetchSaveApply,
  TSaveApplyRequest as IReq,
  ISaveApplyResponse200 as IRes200,
  ISaveApplyResponse400 as IRes400,
} from '../../common/repositories/job-vacancies-backend/v2/save-apply';
import { setErrors, setIsLoading, setIsSubmitted } from './actions';
import { HttpBadStatusCodeError } from '@cian/peperrors/shared';

export const sendApply =
  (data: IReq): TThunkAction<Promise<boolean>> =>
  async (dispatch, getState, context) => {
    const { httpApi, logger } = context;

    dispatch(setIsLoading(true));
    dispatch(setErrors({}));

    try {
      const result = await fetchSaveApply<IRes200, IRes400>({
        httpApi,
        parameters: data,
      });

      if (result.statusCode === 200) {
        dispatch(setIsSubmitted(true));
        dispatch(setIsLoading(false));

        return true;
      }

      const errors: { [key: string]: string } = {};

      result.response.errors?.forEach((error: { key: string; message: string }) => {
        Object.defineProperty(errors, error.key, {
          value: error.message,
        });
      });
      dispatch(setErrors(errors));

      throw new HttpBadStatusCodeError({
        message: result?.response?.message || 'Error in send apply request',
        domain: 'sendApply',
        statusCode: result.statusCode,
      });
    } catch (e) {
      dispatch(setIsLoading(false));
      logger.error(e, { domain: 'sendApply' });

      return false;
    }
  };
